import React from 'react';
import '../less/stakeholders.less';
import Owners from '../../../views/owners.c';
import Reports from '../../../views/newreports/new.reports.c';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock/views/TitleBlock';
import TextBlock from '../../../../../auxiliary-components/shared/TextBlock/views/TextBlock';
import sorry_img from '../../../img/sorry_img.png';
import VerticalTabs from '../../../../../auxiliary-components/shared/VerticalTabs';
import SegmentedStorybook from '@abank/abank-segmented';

export default function template() {
    const navItems = [
        { tab: 'reports', name: 'STAKEHOLDERS_PAGE_TITLE_1' },
        { tab: 'special-info', name: 'STAKEHOLDERS_PAGE_TITLE_2' },
        { tab: 'owners', name: 'STAKEHOLDERS_PAGE_TITLE_3' }
    ];

    const segmentedTabs = navItems.map(tab => ({
      ...tab,
      name: this.l10n(tab.name)
    }));

    const tabContent = [
        <Reports {...this.props} />,
        <div className="stakeholders-special-info">
            <img src={sorry_img} className="stakeholders-special-info__image" alt="sorry" />
            <TitleBlock title="STAKEHOLDERS_SORRY_TITLE" tag="h2" />
            <TextBlock text="STAKEHOLDERS_SORRY_TEXT" />
        </div>,
        <Owners {...this.props} />
    ];

    return (
        <div className="stakeholders-wrapper">
          {!this.state.isSegmentedCollapsed ? (
            <VerticalTabs tabs={navItems} toggle={this.toggleSubMode} tab={this.state.subMode}>
              {tabContent}
            </VerticalTabs>
          ) : (
              <SegmentedStorybook 
                collapsed={true} 
                tabs={segmentedTabs} 
                tab={this.state.subMode} 
                toggle={this.toggleSubMode} 
                leadIcon={false}
              >
                {tabContent}
              </SegmentedStorybook>
            )
          }
        </div>
    );
}
